// Supabase table names constants
export const SUPABASE_TABLES = {
  COMPANIES: 'companies',
  USERS: 'users',
  COMPANY_USERS: 'company_users',
  CUSTOMERS: 'customers',
  SUPPLIERS: 'suppliers',
  SUPPLIER_ADDRESSES: 'supplier_addresses',
  SUPPLIER_CONTACTS: 'supplier_contacts',
  PROJECTS: 'projects',
  ORDERS: 'orders',
  ORDERS_WITH_RELATIONS: 'orders_with_relations',
  ORDER_LINE_ITEMS: 'order_line_items',
  ORDER_LINE_ITEMS_WITH_PARTS: 'order_line_items_with_parts',
  COMPANY_ADDRESSES: 'company_addresses',
  BATCHES: 'batches',
  BATCH_PRODUCTION_STAGE_PLANS: 'batch_production_stage_plans',
  BATCH_CURRENT_STATUS: 'batch_current_status',
  PRODUCTION_STAGES: 'production_stages',
  PROJECT_DOCUMENTS: 'project_documents',
  PRODUCTION_STAGE_DOCUMENTS: 'production_stage_documents',
  PRODUCTION_STAGE_ALLOWED_USERS: 'production_stage_allowed_users',
  QUALITY_CHECKLIST_QUESTIONS: 'quality_checklist_questions',
  QUALITY_CHECKLIST_PDF_REFERENCES: 'quality_checklist_pdf_references',
  QUALITY_CHECKS: 'quality_checks',
  ANSWERS: 'answers',
  PUBLIC_SERIAL_NUMBERS: 'public_serial_numbers',
  PUBLIC_SERIAL_NUMBER_QUALITY_CHECKS: 'public_serial_number_quality_checks',
  USED_SERIAL_NUMBERS: 'used_serial_numbers',
  RESERVED_SERIAL_NUMBER_RANGES: 'reserved_serial_number_ranges',
  TASKS: 'tasks',
  TASK_ATTACHMENTS: 'task_attachments',
  TASK_MENTIONS: 'task_mentions',
  TASK_CHECKLIST_ITEMS: 'task_checklist_items',
  TASK_COMMENTS: 'task_comments',
  BILL_OF_MATERIALS: 'bill_of_materials',
  BILL_OF_MATERIALS_WITH_PARTS: 'bill_of_materials_with_parts',
  PARTS: 'parts',
  PART_ASSEMBLIES: 'part_assemblies',
  PART_ASSEMBLIES_WITH_DETAILS: 'part_assemblies_with_details',
  PARTS_SUPPLIERS: 'parts_suppliers',
  PARTS_SUPPLIERS_WITH_DETAILS: 'parts_suppliers_with_details',
  PARTS_COMPATIBILITY: 'parts_compatibility',
  PARTS_COMPATIBILITY_WITH_DETAILS: 'parts_compatibility_with_details',
  PARTS_DOCUMENTS: 'parts_documents',
  PARTS_PRICE_HISTORY: 'parts_price_history',
  NEW_USER_REQUESTS: 'new_user_requests',
  PROJECT_THUMBNAILS: 'project_thumbnails',
  PAPER_QUALITY_CHECKS: 'paper_quality_checks',
  AUDIT_LOGS: 'audit_logs',
  SIGNED_URL_CACHE: 'signed_url_cache',
  // RFQ tables
  RFQ_REQUESTS: 'rfq_requests',
  RFQ_SUPPLIERS: 'rfq_suppliers',
  RFQ_LINE_ITEMS: 'rfq_line_items',
  RFQ_QUOTES: 'rfq_quotes',
  RFQ_QUOTE_LINE_ITEMS: 'rfq_quote_line_items',
  RFQ_DOCUMENTS: 'rfq_documents',
  RFQ_SUPPLIERS_WITH_DETAILS: 'rfq_suppliers_with_details',
  RFQ_LINE_ITEMS_WITH_DETAILS: 'rfq_line_items_with_details',
  RFQ_QUOTE_LINE_ITEMS_WITH_DETAILS: 'rfq_quote_line_items_with_details',
  RFQ_QUOTES_WITH_DETAILS: 'rfq_quotes_with_details',
  RFQ_SUPPLIER_CAPABILITIES: 'rfq_supplier_capabilities',
  RFQ_SUPPLIER_EMAIL_STATUS: 'rfq_supplier_email_status',
  // Follow-ups tables
  FOLLOW_UP_ACTIONS: 'follow_up_actions',
  FOLLOW_UP_CAMPAIGNS: 'follow_up_campaigns',
  FOLLOW_UP_COMMUNICATIONS: 'follow_up_communications',
  // email tables
  INBOUND_EMAILS: 'inbound_emails',
  EMAIL_QUEUE: 'email_queue',
  SENT_EMAILS: 'sent_emails',
  FAILED_EMAILS: 'failed_emails',
  EMAIL_DRAFTS: 'email_drafts',
  EMAIL_PREFERENCES: 'email_preferences',
  EMAIL_ATTACHMENTS: 'email_attachments',
  EMAIL_SETTINGS: 'email_settings',
  COMPANY_EMAIL_SETTINGS: 'company_email_settings',
  USER_EMAIL_PREFERENCES: 'user_email_preferences',
  AI_SUGGESTIONS: 'ai_suggestions',
} as const;

// Type for table names
export type SupabaseTableName = typeof SUPABASE_TABLES[keyof typeof SUPABASE_TABLES];